import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0540',
    ecrans: ['00-2'],
    params: ['id', 'demcleint', 'stamnetab', '?aftcleintanc', '?aftcleintnou', 'tsecleint']
});
